import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import {
  StrapiLinkDTO,
  LinkDTO,
} from "@lib/strapi/dtos/components/shared/link.dto";

export interface StrapiBreadcrumbSectionDTO
  extends StrapiDynamicZoneComponentDTO {
  style:
    | "Homepage"
    | "Page"
    | "News"
    | "NewsItem"
    | "Events"
    | "Event"
    | "Journal"
    | "Issue"
    | "Article"
    | "People"
    | "Contact"
    | "Policy"
    | "Checkout"
    | "Other";
  links: StrapiLinkDTO[];
  currentPageTitle: string;
  hideShareFunctionality: boolean;
}

export class BreadcrumbSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  style:
    | "Homepage"
    | "Page"
    | "News"
    | "NewsItem"
    | "Events"
    | "Event"
    | "Journal"
    | "Issue"
    | "Article"
    | "People"
    | "Contact"
    | "Policy"
    | "Checkout"
    | "Other";
  links: LinkDTO[];
  currentPageTitle: string;
  hideShareFunctionality: boolean;
}
